import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable";
import { css } from "styled-components";

orderHistoryTableStyles.container = {
    css: css`
        border: 1px solid rgb(204, 204, 204);
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
        overflow: auto;
        margin: 10px 0 0 0;
    `,
};
